import React, { useEffect, useState, useCallback } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
  FormGroup,
} from "reactstrap";
import { Link } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import UserService from "../../../services/KangarooServices/UserService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
import UserForm from "../component/UserForm";
import useIsSmallScreen from "../../../Components/Common/SmallScreen";
import ApproveModal from "../component/ApproveModal";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const User = () => {
  const [customerList, setCustomerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isloading, setIsLoading] = useState(false);

  const [addModal, setAddModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState();
  const navigate = useNavigate();
  const [data, setdata] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [showApprove, setShowApprove] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const isSmallScreen = useIsSmallScreen();
  const toggleModal = (item) => {
    setSelectedCustomer(item);
    setIsModalOpen(!isModalOpen);
  };

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const toggleApprove = () => setShowApprove(!showApprove);

  const handleApproveClick = (user) => {
    setSelectedUser(user);
    toggleApprove();
  };

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const fetchdata = async () => {
    setLoading(true);
    try {
      const data = await UserService.getList();
      setdata(data);
      console.log("Fetched user:", data);
    } catch (error) {
      console.error("Error getting user:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchdata();
  }, []);

  const handleNotificationStatus = async (id, enable) => {
    try {
      const response = await UserService.updateNotification(id, enable);
      fetchdata();
      toast.success(response);
    } catch (error) {
      console.log(error);
      toast.error(response);
    }
  };
  const userType = [
    { id: 1, label: "Onshore" },
    { id: 2, label: "Offshore" },
    { id: 3, label: "Kampus" },
    { id: 4, label: "BID Offshore" },
    { id: 5, label: "BID Onshore" },
  ];
  const columns = [
    {
      name: "S. N",
      cell: (row, index) => (
        <div>{(currentPage - 1) * rowsPerPage + index + 1}</div>
      ),
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => `${row.fullName}`,
      cell: (row) => <Link to={`/user/${row?.id}`}>{row.fullName}</Link>,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      cell: (row) => (
        <span title={row.email} className="cursor-pointer">
          {row.email}
        </span>
      ),
      sortable: true,
      width: "15vw",
    },
    {
      name: "Phone No",
      selector: (row) => row.phone,
      sortable: true,
    },
    {
      name: "Roles",
      selector: (row) => row.roles[0],
      sortable: true,
    },
    {
      name: "User Form",
      selector: (row) => row.userFrom,
      sortable: true,
      cell: (row) => (
        <div>{userType?.find((x) => x.id === row.userFrom)?.label}</div>
      ),
    },
    // {
    //   name: "Status",
    //   selector: (row) => row.isActive,
    //   sortable: true,
    //   cell: (row) => (
    //     <Badge color={row.isActive ? "success" : "danger"}>
    //       {row.isActive ? "Active" : "Inactive"}
    //     </Badge>
    //   ),
    // },
    {
      name: "Approve",
      selector: (row) => row.isAdminApproved,
      sortable: true,
      cell: (row) => (
        <Badge color={row.isAdminApproved ? "success" : "danger"}>
          {row.isAdminApproved ? "Approved" : "UnApproved"}
        </Badge>
      ),
    },
    {
      name: "Notification",
      selector: (row) => row.sendEmailOnContentUpdate,
      sortable: true,
      cell: (row) => (
        <FormGroup switch>
          <Input
            type="switch"
            role="switch"
            checked={row.sendEmailOnContentUpdate} // assuming API gives enable status
            onChange={(e) => handleNotificationStatus(row.id, e.target.checked)}
          />
        </FormGroup>
      ),
      center: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div>
          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            onClick={() => toggleModal(row)}
          >
            <i className="ri-edit-line" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
          <Button
            className={`btn btn-sm ms-1 ${
              row.isAdminApproved ? "btn-soft-secondary" : "btn-soft-success"
            }`}
            color={row.isAdminApproved ? "secondary" : "success"}
            onClick={() => handleApproveClick(row)}
            title={row.isAdminApproved ? "Unapprove" : "Approve"}
          >
            <i
              className={
                row.isAdminApproved ? "ri-close-line" : "ri-check-line"
              }
            />
          </Button>
        </div>
      ),
    },
  ];

  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = data?.filter((pkg) => {
    const searchContext = `${pkg?.fullName || ""} ${pkg?.phone || ""} ${
      pkg?.email || ""
    }`.toLowerCase();
    const matchesFilter = searchContext.includes(filterText.toLowerCase());
    return matchesFilter;
  });

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      setLoading(true);
      try {
        await UserService.delete(selectedDeleteItem.id);
        await fetchdata();
        toast.success("User deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete User");
      } finally {
        setLoading(false);

        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  const confirmApprove = async () => {
    if (!selectedUser) return;
    setIsLoading(true);

    try {
      const newStatus = !selectedUser.isAdminApproved;

      await UserService.approveUser(selectedUser.id, newStatus);

      toast.success(
        `User ${newStatus ? "Approved" : "UnApproved"} successfully!`,
      );

      toggleApprove();

      await fetchdata();
    } catch (error) {
      toast.error("Failed to update user.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Users" pageTitle="User Management" />
      </div>
      <Row>
        <Col md={8} xs={12} className="mb-2">
          <InputGroup>
            <Input
              placeholder="Search by name, email & phone number"
              value={filterText}
              onChange={handleFilterChange}
              style={{
                borderRadius: isSmallScreen ? "8px" : undefined,
                padding: isSmallScreen ? "12px 16px" : undefined,
              }}
            />
          </InputGroup>
        </Col>
        <Col
          md={4}
          xs={12}
          className="d-lg-flex d-none justify-content-end align-items-end mb-2"
        >
          <button
            className="btn btn-success px-1 px-sm-2"
            onClick={toggleModal}
          >
            + Add User
          </button>
        </Col>
      </Row>

      {isSmallScreen ? (
        <>
          {/* Floating Add Button for Mobile */}
          <button
            className="btn btn-success d-lg-none"
            onClick={toggleModal}
            style={{
              position: "fixed",
              bottom: "24px",
              right: "24px",
              borderRadius: "50%",
              width: "56px",
              height: "56px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "24px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              zIndex: 1000,
              border: "none",
            }}
          >
            <i className="ri-add-line"></i>
          </button>

          {loading ? (
            <div className="d-flex justify-content-center my-5">
              <Triangle visible={true} height="80" width="80" color="#5B71B9" />
            </div>
          ) : filteredData.length === 0 ? (
            <div className="text-center py-5">
              <i
                className="ri-user-search-line"
                style={{ fontSize: "48px", color: "#999" }}
              ></i>
              <p className="text-muted mt-3">No users found</p>
            </div>
          ) : (
            <div style={{ paddingBottom: "80px" }}>
              {filteredData.map((user, index) => (
                <Card
                  key={user.id || index}
                  className="mb-3"
                  style={{
                    borderRadius: "12px",
                    border: "1px solid #e8e8e8",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                    overflow: "hidden",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => navigate(`/user/${user.id}`)}
                >
                  <CardBody style={{ padding: "16px" }}>
                    <Row className="justify-content-between">
                      {/* <Col xs={2} className="d-flex align-items-center justify-content-center">
                        <div
                          // style={{
                          //   width: "48px",
                          //   height: "48px",
                          //   borderRadius: "50%",
                          //   background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          //   display: "flex",
                          //   alignItems: "center",
                          //   justifyContent: "center",
                          //   color: "white",
                          //   fontSize: "20px",
                          //   fontWeight: "600",
                          // }}
                        >
                          {user.fullName?.charAt(0)?.toUpperCase() || "U"}
                        </div>
                      </Col> */}

                      <Col xs={8} style={{ paddingLeft: "8px" }}>
                        <h6
                          className="mb-1"
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#2c3e50",
                          }}
                        >
                          {user.fullName}
                        </h6>

                        <div className="d-flex align-items-center mb-1">
                          <i
                            className="ri-mail-line"
                            style={{
                              fontSize: "14px",
                              color: "#7f8c8d",
                              marginRight: "6px",
                            }}
                          ></i>
                          <span
                            style={{
                              fontSize: "13px",
                              color: "#7f8c8d",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {user.email}
                          </span>
                        </div>

                        <div className="d-flex align-items-center mb-2">
                          <i
                            className="ri-phone-line"
                            style={{
                              fontSize: "14px",
                              color: "#7f8c8d",
                              marginRight: "6px",
                            }}
                          ></i>
                          <span style={{ fontSize: "13px", color: "#7f8c8d" }}>
                            {user.phone}
                          </span>
                        </div>

                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <Badge
                            color="primary"
                            style={{
                              padding: "4px 10px",
                              fontSize: "11px",
                              fontWeight: "500",
                              borderRadius: "6px",
                            }}
                          >
                            {user.roles[0]}
                          </Badge>
                          <Badge
                            color={user.isActive ? "success" : "danger"}
                            style={{
                              padding: "4px 10px",
                              fontSize: "11px",
                              fontWeight: "500",
                              borderRadius: "6px",
                            }}
                          >
                            {user.isActive ? "Active" : "Inactive"}
                          </Badge>
                        </div>
                      </Col>

                      <Col
                        xs={2}
                        className="d-flex align-items-start justify-content-end"
                      >
                        <Dropdown
                          isOpen={user.dropdownOpen || false}
                          toggle={(e) => {
                            e.stopPropagation();
                            setdata((prev) =>
                              prev.map((u) =>
                                u.id === user.id
                                  ? { ...u, dropdownOpen: !u.dropdownOpen }
                                  : { ...u, dropdownOpen: false },
                              ),
                            );
                          }}
                        >
                          <DropdownToggle
                            color="light"
                            className="btn-sm shadow-none"
                            style={{
                              borderRadius: "8px",
                              padding: "6px 10px",
                              border: "1px solid #e8e8e8",
                            }}
                          >
                            <i
                              className="ri-more-2-fill"
                              style={{ fontSize: "18px", color: "#495057" }}
                            ></i>
                          </DropdownToggle>
                          <DropdownMenu end>
                            <DropdownItem
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleModal(user);
                              }}
                            >
                              <i className="ri-edit-line text-warning me-2"></i>{" "}
                              Edit
                            </DropdownItem>
                            <DropdownItem
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteClick(user);
                              }}
                            >
                              <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                              Delete
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              ))}
            </div>
          )}
        </>
      ) : (
        <CustomDataTable
          responsive
          striped
          pagination
          fixedHeader
          persistTableHead
          progressPending={loading}
          customStyles={customStyles}
          paginationPerPage={rowsPerPage}
          onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)}
          onChangePage={(page) => setCurrentPage(page)}
          progressComponent={
            <div className="my-3">
              <Triangle
                visible={true}
                height="80"
                width="80"
                color="#5B71B9"
                ariaLabel="triangle-loading"
              />
              <h5 className="mt-1">Loading...</h5>
            </div>
          }
          columns={columns}
          data={filteredData}
        />
      )}

      <UserForm
        isOpen={isModalOpen}
        toggle={toggleModal}
        selectedItem={selectedCustomer}
        fetchdata={fetchdata}
      />
      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />

      <ApproveModal
        show={showApprove}
        onApproveClick={confirmApprove}
        onCloseClick={toggleApprove}
        setLoading={setIsLoading}
        loading={isloading}
        selectedUser={selectedUser}
      />
    </div>
  );
};

export default User;
